import { BrainfishWidgetError } from '@brainfish-ai/widgets-common';
import { kyPost } from './post-request';
import { Endpoints } from '../endpoints';

export const API_HOST = import.meta.env.VITE_API_HOST;
export const IS_PRODUCTION = import.meta.env.MODE === 'production';

const sendError = ({
  error,
  widgetKey,
}: {
  error: BrainfishWidgetError;
  widgetKey: string;
}) => {
  const trackErrorEndpoint = Endpoints.Widget.TrackError;
  // don't send error if Node environment is not production
  if (!IS_PRODUCTION) return;

  kyPost<any>({
    endpoint: `${API_HOST}/api/${trackErrorEndpoint}`,
    apiKey: widgetKey,
    requestBody: {
      error: error.message,
      stack: error.stack,
      cause: {
        message: error.cause?.message,
        stack: error.cause?.stack,
        cause: error.cause?.cause,
      },
    },
  });
};

export type Extras = {
  function: string;
  filename: string;
  widgetKey: string;
  version: string;
} & Record<string, any>;

const Logger = {
  error: (message: string, error: Error, extras: Extras) => {
    const bfError = new BrainfishWidgetError(message, {
      cause: error,
    });
    console.error(`BrainfishWidgetError: ${message}`, bfError, extras);
    sendError({
      error: bfError,
      widgetKey: extras.widgetKey,
    });
  },
  info: (message: string, extras?: any) => {
    console.info(`BrainfishWidgetInfo: ${message}`, extras);
  },
  warn: (message: string, extras?: any) => {
    console.warn(`BrainfishWidgetWarn: ${message}`, extras);
  },
};

export { Logger };
